// Converts some ugly liquid output into JSON. Used when parsing metafields.
function liquidToJSON(liquidString) {
  return JSON.parse(liquidString
    .replace(/"/g, '\"')
    .replace(/=>/g, ': ')
    .replace(/"{/g, '{')
    .replace(/}"/g, '}')
    .replace(/"\[/g, '[')
    .replace(/\]"/g, ']')
    .replace(/nil/g, 'null'));
}

// Processes Color Data from Server and assigns some default values
function processColors() {
  // Just grab all the ID's and throw them into their respective arrays
  _.each(productMetafields.colors, function(v, k) {
    primaryColors.push(parseInt(k));
    secondaryColors = _.concat(secondaryColors, v);
  });

  _.each(productMetafields.qd_inventory, function(v, k) {
    qdColors.push(parseInt(k));
  });

  // Reduce the values to only sorted uniques.
  primaryColors = _.uniq(primaryColors).sort(function(a, b){return a-b});
  secondaryColors = _.uniq(secondaryColors).sort(function(a, b){return a-b});
  qdColors = _.uniq(qdColors).sort(function(a, b){return a-b});

  // Set the default color selection to the first element of each type;
  selectedPrimary = (primaryColors.length > 0) ? allColors[primaryColors[0]] : null;
  selectedSecondary = (secondaryColors.length > 0) ? allColors[secondaryColors[0]] : null;
}

// Generate HTML elements and output color grid
function createColorOptions() {

  // Create HTML elements, populate data attributes, and add click handler.
  var primaryColorElements = generateColorElements(primaryColors, 'primary');
  var secondaryColorElements = generateColorElements(secondaryColors, 'secondary');

  // Output the color grid on the page
  generateColorDOM();
  generateColorGrid(primaryColorElements, 'ul#primary');
  generateColorGrid(secondaryColorElements, 'ul#secondary');
}


// Builds headings & ULs for the color section
function generateColorDOM() {
  var colorDOM = [];

  if (qdColors.length > 0) {
    colorDOM.push('<a class="toggle-qd">Show Only In-Stock Colors</a>');
  }

  if (primaryColors.length > 0) {
    colorDOM.push('<h3>Primary Colors: <span class="primary-selection"></span></h3>');
    colorDOM.push('<ul id="primary" class="clearfix"></ul>');
  }
  if (secondaryColors.length > 0) {
    colorDOM.push('<h3>Secondary Colors: <span class="secondary-selection"></span></h3>');
    colorDOM.push('<ul id="secondary" class="clearfix"></ul>');
  }
  $('#color-container').html(colorDOM.join(''));
}

// Iterates through a collection of generated list items (elements) and
// appends them to the chosen color grid (selector)
function generateColorGrid(elements, selector) {
  _.each(elements, function(element) {
    element.appendTo(selector);
  });
}

// Generates list items for each color
function generateColorElements(colorIds, type) {
  elementContainer = [];
  _.each(colorIds, function(id) {
    var colorInfo = allColors[id];
    var backgroundCSS = 'background: #' + colorInfo['hex'];
    var imageUrl = storeMetafields.color_base_url + colorInfo['image'];

    // Add <a> element
    var newChildEl = $('<a/>', {
      'id': colorInfo['name'],
      'style': backgroundCSS,
    }).add(displayTooltip(colorInfo));

    // Add parent <li> to wrap both elements
    var liParams = {
      'class': 'color active',
      'data-color-id' : id,
      'data-type': type,
      'data-color-id' : id,
      'data-color-name': colorInfo['name'],
      'data-combinations': formatCombinations(id, type),
      'data-image-url': imageUrl,
      'click': function() {
        if ($(this).hasClass('active')) { handleColorSelection($(this)) };
      },
      'hover': function() {
        if ($(this).hasClass('active')) { $(this).children('.tooltip').toggleClass('active') };
      }
    };

    if (type == 'primary' && qdColors.length > 0) {
      if (qdColors.indexOf(id) !== -1) { liParams['data-qd'] = true }
    }

    var newParentEl = $('<li/>', liParams).html(newChildEl);
    elementContainer.push(newParentEl);
  });
  return elementContainer;
}

// Return either all secondary colors, or an empty array
function formatCombinations(id, type) {
  if (type == 'primary') {
    return productMetafields.colors[id].sort(function(a, b){return a-b});
  } else {
    return [];
  }
}

// When a color is selected, do stuff:
function handleColorSelection(self) {
  updateColorSelection(self);
  markActive(self);
  toggleSecondaryColorCombinations(self);
  updateColorSelectionDisplay();
  toggleImages();
  formatSwatchArea();
  updateLineItems();
  togglePremiumPriceVariant(self);
  toggleProductVariant();
  $('#inventory-message').hide();
}

function markActive(self) {
  var type = self.data('type');
  $('ul#' + type + ' li').removeClass('selected-color');
  self.addClass('selected-color');
  // add custom event
  self.trigger('color-select');
}

// Generates the content of a tooltip, which is added to the color grid
function displayTooltip(colorInfo) {
  var output = colorInfo['name'];
  if (colorInfo['cost'] !== '0') {
    output += ' +$' + colorInfo['cost'];
  }
  return '<div class="tooltip">' + output + '</div>';
}

// Only applies to primary colors, when secondaryColors are present
function toggleSecondaryColorCombinations(self) {
  if (secondaryColors.length > 0 && self.data('type') == 'primary') {
    var colorCombos = null;
    var is_qd = (self.data('qd') && $('.toggle-qd.in-stock-toggled').length > 0 );
    $('ul#secondary li').removeClass('active');

    // Choose secondary color combinations based on if we've selected all colors or just what's in stock
    if (is_qd) {
      colorCombos = productMetafields.qd_inventory[self.data("color-id")];
    } else {
      colorCombos = self.data('combinations').toString().split(',');
    }

    // iterate over the list of valid combinations to give them the appropriate class
    _.each(colorCombos, function (cc) {
      $('ul#secondary li[data-color-id=' + cc + ']').addClass('active');
    });

    // If the current secondary color is not within the list of valid secondaries
    // for this element, change selectedSecondary to the first valid option.
    var secondaryValid = $('#secondary li[data-color-name="' + selectedSecondary.name + '"]').hasClass('active');
    if (!secondaryValid) {
      selectedSecondary = allColors[colorCombos[0]];
    }
  }

}

// Updates the color selection based on what the user selected
function updateColorSelection(self) {
  var colorData = allColors[self.data('color-id')];
  switch(self.data('type')) {
    case 'primary':
      selectedPrimary = colorData;
      break;
    case 'secondary':
      selectedSecondary = colorData;
      break;
  }
}

function updateColorSelectionDisplay() {
  $('.primary-selection').html(selectedPrimary.name);
  if (secondaryColors.length > 0) {
    $('.secondary-selection').html(selectedSecondary.name);
  }
}

// Generate a product SKU using the two methods below.
// Product SKU can be any of these combinations:
// 8773        - Just ID
// 8773 -BLUE   - Primary Color only
// 8773 s-BLUE  - Primary & Secondary colors are the same, so a single 's' is used.
// 8773 wh-BLUE - Primary (Blue) & Secondary (White) colors are different
function productSKU() {
  var sku = productMetafields.dessy_id;
  if (selectedPrimary && !selectedSecondary) { sku += '-' }
  sku += productColorCode();
  return sku;
}

// Returns a color code, used by the inventory API, product SKU, etc.
// Returns either "BLUE", "s-BLUE", or "wh-BLUE".
// See above for more info.
function productColorCode() {
  var colorCode = '';
  // Assemble everything after the stylecode.
  if (primaryColors.length > 0 ) {

    // Add a 2-character prefix to the sku if a secondary color is present.
    if (secondaryColors.length > 0 && selectedSecondary) {
      colorCode += generateTwoLetterCode() + '-';
    }

    // Add a 4-character prefix to the end of the SKU.
    if (selectedPrimary) {
      colorCode += selectedPrimary.fourlettercode;
    }
  }
  return colorCode;
}

// Returns a formatted color name such as 'amethyst/amethyst'
function fullColorName() {
  var color = '';

  if (selectedPrimary) {
    color += selectedPrimary.name;
  }

  if (selectedSecondary) {
    color += '/' + selectedSecondary.name;
  }

  return color;
}

// Updates the Line Item Attributes of a Product
function updateLineItems() {
  $('.sku-prop').val(productSKU());
  $('.color-prop').val(fullColorName());
}

// Toggles change on the hidden premium price variant
function togglePremiumPriceVariant(self) {
  if (productOptions.indexOf('Premium Color') !== -1) {
    var hasPremiumColor = true;
  } else {
    var hasPremiumColor = false;
  }


  // Toggle premium color variant DOM
  if (hasPremiumColor) {
    var premiumColorIndex = productOptions.indexOf('Premium Color') + 1;
    var premiumSelect = $('select[data-index=option' + premiumColorIndex + ']');
    var colorID = self.data('color-id');

    if (allColors[colorID].has_cost) {
      premiumSelect.val('Yes +$10').change();
    } else {
      premiumSelect.val('No').change();
    }
  }
}

// Generates a hidden premium price <select> tag to handle premium color options,
// if the product includes premium color as an option.
function generatePremiumPriceSelect() {
  if (productOptions.indexOf('Premium Color') !== -1) {
    var hasPremiumColor = true;
  } else {
    var hasPremiumColor = false;
  }


  if (hasPremiumColor) {
    var premiumColorIndex = productOptions.indexOf('Premium Color') + 1;
    $('form.product-form').append('<select class="single-option-selector single-option-selector-product-template product-form__input" style="display:none;" id="premium-color-variant" data-index="option' + premiumColorIndex + '"><option value="No" selected="selected">No</option><option value="Yes +$10">Yes +$10</option></select>');
  }
}

// Return either a 2-letter code for a secondary color, or the character 's'
// if the two selected colors are the same.
function generateTwoLetterCode() {
  if (selectedPrimary.name == selectedSecondary.name) {
    return 's';
  } else {
    return selectedSecondary.twolettercode;
  }
}

// When a color is selected, update the image URL's accoringly
function toggleImages() {
  var productUrlString = 'http://s0.dessy.com/s/i/product/' + productMetafields.dessy_id + '/' + productSKU() + '-';
  $('img.product-thumb[data-orientation=front]').attr('src', productUrlString + 'front-mid.jpg');
  $('img.product-thumb[data-orientation=rear]').attr('src', productUrlString + 'rear-mid.jpg');

  // Also add to line item property for cart
  $('.selected-image-prop').val(productUrlString + 'front-mid.jpg');

  // Clear and replace existing elevateZoom data
  $('.zoomContainer').remove();

  // Replace main image & elevateZoom data based on which thumbnail was clicked
  $('img.main-product-image')
    .removeData('elevateZoom')
    .attr('src', productUrlString + 'front-big.jpg')
    .data('zoom-image', productUrlString + 'front-yawah.jpg')
    .elevateZoom(zoomParams);
}


// Fetch the pre-generated style chart using the Dessy API and the
function generateStyleChart() {
  if (productMetafields.stylecode) {
    var url = 'https://dessy.com/api/sizechart.ashx?stylecode=' + productMetafields.stylecode + '&orientation=horizontal';

    $.get(url, function(data) {
      $('#sizing-chart').html(data);
    });
  }
}

// Adds a link to order a swatch, along with the primary color, if colors are present.
function formatSwatchArea() {
  if (productMetafields.fabrics && productMetafields.fabrics.primary && productMetafields.fabrics.primary.productid > 0) {
    var swatch = productMetafields.fabrics.primary.name;
    var colorID = selectedPrimary.dessy_id;
    var swatchPath = '/products/' + swatch.toLowerCase().replace(/ /g, '-') + '-swatch?colorid=' + colorID;
    var colorContent = '';

    if (selectedPrimary) {
      colorContent = '<span class="swatch-color" style="background: #' + selectedPrimary.hex + ';"></span>Order Free Swatch - ' + selectedPrimary.name;
    } else {
      colorContent = 'Order Free Swatch';
    }

    $('#swatch-url')
      .attr('href', swatchPath)
      .css({'text-transform': 'uppercase'})
      .html(colorContent);
  } else {
    $('.product-swatch__order').hide();
  }

}

// Outputs some DOM containing product info bullet points
function generateBullets() {
  var bulletsDOM = [];
  _.each(productMetafields.bullets, function(b) {
    if (b.length > 0) {
      bulletsDOM.push('<li>' + b + '</li>');
    }
  });
  $('#bullets').html(bulletsDOM);
}

// Fetches the current value of a product option <select> using the given index.
function variantValue(index) {
  return $('[data-index=option' + (index + 1) + ']').val();
}

// Toggles the product variant when color or other options are changed
function toggleProductVariant() {
  if (meta.product.variants.length > 0) {
    // Get the selected variant (can be the default)
    var variantValues = $('#ProductSelect option:selected').text().split(" - ")[0].split(" / ");

    // Iterate through each productOption to assemble the string.
    _.each(productOptions, function(v, k) {

      // Get the value of the select box.
      var val = variantValue(k);

      // If nothing was selected, use the default or current value.
      if (val == null) {
        val = variantValues[k].trim();
      }

      variantValues[k] = val;
    });

    // Re-assemble the variant string and compare with the list of all
    // available variants.
    var variantString = variantValues.join(' / ');
    _.each(meta.product.variants, function(variant) {
      if (variant.public_title == variantString) {
        updateVariantElements(variant);
      }
    });
  }
}

// Updates variant elements, like price containers and the actual variant <select> tag.
function updateVariantElements(variant) {
  // Update price
  var priceFloat = (variant.price / 100 ).toFixed(2);
  $('#ProductPrice-product-template')
    .attr('content', priceFloat)
    .html('$' + priceFloat);

  // Toggle variant change
  $('#ProductSelect').val(variant.id).change();
}

// Replace the big image when you click a thumbnail
function loadImageThumbnailToggle() {
  $('img.product-thumb').click(function() {
    var orientation = $(this).data("orientation");
    var productImage = $(this).attr('src').replace("-mid.jpg", "");

    // Clear existing elevateZoom data
    $('.zoomContainer').remove();

    // Replace main image & elevateZoom data based on which thumbnail was clicked
    $('img.main-product-image')
      .removeData('elevateZoom')
      .attr('src', productImage + "-big.jpg")
      .data('zoom-image', productImage + '-yawah.jpg')
      .elevateZoom(zoomParams);
  });
}

// if a product is In Stock, this toggle will show/hide in stock products.
function loadInStockToggle() {
  $('.toggle-qd').click(function() {
    var self = $(this);
    var text = '';

    self.toggleClass('in-stock-toggled');

    // Showing only in-stock, so prompt the user to change it back to all colors.
    if (self.hasClass('in-stock-toggled')) {
      text = "Show All Colors";
      $('.color:not([data-qd])').removeClass('active');
      $('#shipping-type').html('In Stock')
      $('#shipping-duration').html(productMetafields.shipping_times.instock);
      toggleExtraLength('off');
      togglePlusSizes('off');

      $('#instock-delivery').prop('disabled', false).parents('li').show();
      $('.shipping-type:not(#instock-delivery)').prop('disabled', true).parents('li').hide();

      $('input[name="properties[Shipping Options]"]').prop('checked', false);
      $('#AddToCart-product-template').attr('disabled', 'disabled');

      // Hang a click event on the "in stock shipping" button so checkout can be completed
      $('#instock-delivery').click(function() {
        $('#AddToCart-product-template').removeAttr('disabled');
      })

      // Since we're only showing in-stock, make sure the selected primary color is in that list as well.
      var primary = $('#primary li[data-color-id=' + selectedPrimary.dessy_id + ']');
      var is_qd = (primary.data('qd') && $('.toggle-qd.in-stock-toggled').length > 0 );
      if (is_qd) {
        primary.click();
      } else {
        selectedPrimary = allColors[qdColors[0]];
        $('#primary li[data-color-id=' + selectedPrimary.dessy_id + ']').click();
      }

    // Showing all colors, so prompt the user to show only what's in stock.
    } else {
      text = "Show Only In-Stock Colors";
      $('.color').addClass('active');
      $('#instock-delivery').prop('disabled', true).parents('li').hide();
      $('.shipping-type:not(#instock-delivery)').prop('disabled', false).parents('li').show();
      $('.shipping-type:not(#instock-delivery)').first().change();
      $('#shipping-type').html('Special Order')
      $('#shipping-duration').html(productMetafields.shipping_times.standard);
      $('#inventory-message').hide();
      $('#AddToCart-product-template').removeAttr('disabled');
      toggleExtraLength('on');
      togglePlusSizes('on');
    }
    self.html(text);
  });
}

// Toggles inventory handlers on In-Stock colors
function loadInventoryCheckHandler() {

  // Fetch inventory for selected color on page load
  handleInventoryForColor();

  // Fetch inventory on color change
  $('li.color').on('color-select', function() {
    handleInventoryForColor();
  });

  // Update inventory stuff when select is changed
  $('[data-index=option1]').change(function() {
    var selectedSize = $(this).val();
    handleInventoryForSize(selectedSize);
  });
}

// Returns true if in stock is not enforced or toggled.
function notInStock() {
  return !(inStockOnly || $('.toggle-qd').hasClass('in-stock-toggled'));
}

// Fetch inventory by SKU + Color from Dessy.com
function handleInventoryForColor() {
  if (notInStock()) return true;

  var inventoryMessage;
  var sizeSelector = $('[data-index=option1]');

  // set the size selector value to null
  // so that an inappropriate size is not selected when the color changes
  sizeSelector.val(null);

  // hide all size options (except the placeholder) so they can be shown individually based on the colorInventory
  if (typeof sizeOptions === 'undefined') {
    sizeOptions = sizeSelector.find('option:not(:first)').detach();
  } else {
    sizeOptions.add(sizeSelector.find('option:not(:first)').detach());
  }

  // request the stock for this color
  $.get(getInventoryURL(), function(response) {
    // Assign current inventory from API response
    colorInventory = JSON.parse(response);

    // Render size options if inventory was returned
    if (colorInventory.length > 0) {

      // Sort colorInventory by size (starting with '00')
      colorInventory.sort(function(a, b) {
        if (a['Size'] == '00') { return -1 }
        return parseInt(a['Size']) > parseInt(b['Size']) ? 1 : -1
      });

      // Iterate through colorInventory and add to select tag if inventory is present.
      _.each(colorInventory, function(item) {
        var sizeOption = sizeOptions.filter(function() { return $(this).val() === item["Size"] })
        if (item["Quantity"] > 0) { sizeOption.appendTo(sizeSelector); }
      });

      // Ensure size select is rendered
      sizeSelector.show();

    // Render error message when no inventory was returned
    } else {
      inventoryMessage = 'Sorry, this color is currently out of stock for all sizes';
      hideSizeSelection(sizeSelector, inventoryMessage);
    }

  // Render API failure message
  }).fail(function() {
    inventoryMessage = "Couldn't load available sizes - please try again in a few minutes";
    hideSizeSelection(sizeSelector, inventoryMessage);
  });
}

// Hides size select + renders message when inventory check fails.
function hideSizeSelection(sizeSelector, inventoryMessage) {

  // Hide the select tag.
  sizeSelector.hide();

  // Disable add to cart button
  $('#AddToCart-product-template').attr('disabled', 'disabled');

  // Hide in-stock shipping option and de-select all shipping options
  $('#instock-delivery').parent('li').hide();
  $('input[name="properties[Shipping Options]"]').prop('checked', false);

  // Render the failure message
  $('#inventory-message').html(inventoryMessage).attr('class', 'failure').show();
}

// Generate the inventory url with dynamic rootsku and colorsku
function getInventoryURL() {
  return 'https://ca.dessy.com/services/InventoryChecklist.ashx?rootsku=' + productMetafields.stylecode + '&colorsku=' + productColorCode() + '&inventorytype=instock';
}

// Toggle inventory messages when size is changed
function handleInventoryForSize(selectedSize) {
  if (notInStock()) return true;

  var inventoryMessage;

  // Disable add to cart button so it can be enabled when the selected size is in stock
  $('#AddToCart-product-template').attr('disabled', 'disabled');

  // Do stuff if inventory for selected color is available and a size has been selected
  if ((typeof colorInventory !== 'undefined') && (selectedSize !== null)) {
    // Get quantity for selected size
    var selectedSizeInventory = colorInventory.find(function(item) { return item["Size"] === selectedSize; });

    // Update the hidden line item so we can pass the value through to the cart
    $('.max-qty-prop').val(selectedSizeInventory['Quantity']);

    // Show the In-stock shipping option & Toggle it
    $('#instock-delivery').parent('li').show();
    $('#instock-delivery').prop('checked', true).change();

    // Assign message depending on qty available
    if (selectedSizeInventory['Quantity'] > 10) {
      inventoryMessage = 'Your selection is in stock!';
    } else {
      inventoryMessage = 'There are <strong>' + selectedSizeInventory['Quantity'] + '</strong> products left in stock for ' + fullColorName() + ' in your current size selection';
    }

    // Render message
    $('#inventory-message').html(inventoryMessage).attr('class', 'success').show();

    // Re-enable the add to cart button
    $('#AddToCart-product-template').removeAttr('disabled');

  // Do stuff if no inventory is available or no size selected
  } else {

    // Hide in-stock shipping option and de-select all shipping options
    $('#instock-delivery').parent('li').hide();
    $('input[name="properties[Shipping Options]"]').prop('checked', false);

    // Clear the inventory message
    $('#inventory-message').html('').attr('class', '').hide();
  }
}

// Returns something like this:
// "This item will leave our warehouse between approximately October 26, 2017 and November 02, 2017."
function wearDate(estimate) {
  var date = estimate.split(' ');
  var dateUnit = date[1];

  if (date[0].indexOf('-') !== -1) {
    var dateInterval = date[0].split('-');
    var output = 'This item will leave our warehouse between approximately ' + formatDate(dateInterval[0], dateUnit) + ' and ' + formatDate(dateInterval[1], dateUnit);
  } else {
    var output = 'This item will leave our warehouse by approximately ' + formatDate(date[0], dateUnit);
  }

  return output;
}

// Returns a date like 01/12/2017
function hiddenWearDate(estimate) {
   var date = estimate.split(' ');
   var dateUnit = date[1];
   if (date[0].indexOf('-') !== -1) {
     var dateInterval = date[0].split('-')[1];
   } else {
     var dateInterval = date[0]
   }
   return moment().add(dateInterval, dateUnit).format('YYYY-MM-DD');
}

// Formats a date like: November 01, 2017
function formatDate(interval, unit) {
  return moment().add(interval, unit).format('MMMM DD, YYYY');
}

// Toggles extra length to "no" when an in-stock product is selected.
function toggleExtraLength(toggle) {
  var hasExtraLength = _.filter(productOptions, function(opt) {
    return (opt.indexOf('Extra Length') !== -1 );
  });

  // Toggle extra length variant DOM
  if (hasExtraLength.length > 0) {
    var extraLengthLabel = hasExtraLength[0];
    var extraLengthIndex = productOptions.indexOf(extraLengthLabel) + 1;
    var extraLengthSelect = $('select[data-index=option' + extraLengthIndex + ']');
    if (toggle == 'off') {
      extraLengthSelect.val('No').change();
      extraLengthSelect.prev('label').hide();
      extraLengthSelect.hide();
    } else {
      extraLengthSelect.prev('label').show();
      extraLengthSelect.show();
    }
  }
}

// If QD Inventory is selected, inventory options are limited t
function togglePlusSizes(toggle) {
  if (productOptions.indexOf('Size') == 0) {
    var plusSizeOptions = $('[data-index=option1] option[value^="18W"]').nextAll();
    var sizeDoubleZero = $('[data-index=option1] option[value="00"]');

    if (toggle == "off") {
      plusSizeOptions.hide();
      sizeDoubleZero.hide();
    } else {
      plusSizeOptions.show();
      sizeDoubleZero.show();
    }
  };
}

// Toggles the default color selection
function handleDefaultColorSelection(colorFamily, colorID) {
  if (colorFamily) {
    var color = productMetafields.color_family_images[colorFamily].name;
    $('#primary .color[data-color-name="' + color + '"]').click();
  } else if (colorID) {
    var color = allColors[colorID].name;
    $('#primary .color[data-color-name="' + color + '"]').click();
  } else {
    var colors = productMetafields.default_color.split(" / ");
    $('#primary .color[data-color-name="' + colors[0] + '"]').click();
    if (colors.length > 1) {
      $('#secondary .color[data-color-name="' + colors[1] + '"]').click();
    }
  }

}

function toggleAvailableShippingTypes(availableShippingTypes) {
  if (!availableShippingTypes['instock']) {
    $('#instock-delivery').parent('li').remove();
  }
  if (!availableShippingTypes['standard']) {
    $('#standard-delivery').parent('li').remove();
  }
  if (!availableShippingTypes['rush']) {
    $('#rush-delivery').parent('li').remove();
  }
  if (!availableShippingTypes['superRush']) {
    $('#super-rush-delivery').parent('li').remove();
  }
}
